import * as React from 'react';
import { styled } from '@linaria/react';

import Space from '@/components/Space';
import FakeBrowserWindow from '@/components/FakeBrowserWindow';
import SliderControl from '@/components/Controls/SliderControl';

type Fix = 'blurrier' | 'background' | 'brightness';

function TheProblem({ fix }: { fix?: Fix }) {
  const [radius, setRadius] = React.useState(
    fix === 'blurrier' ? 12 : 5
  );
  const [opacity, setOpacity] = React.useState(
    fix === 'background' ? 0.6 : 0
  );
  return (
    <OuterWrapper>
      <Browser maxHeight="16rem">
        <Wrapper>
          <Header
            style={{
              background: `hsl(210deg 15% 6% / ${opacity})`,
            }}
          >
            <GlassyBackdrop
              style={{
                '--radius': radius + 'px',
              }}
            />
            <HeaderContent>
              <Title>Some Website</Title>
              <nav>
                <ul>
                  <li>Home</li>
                  <li>Shop</li>
                  <li>Contact</li>
                </ul>
              </nav>
            </HeaderContent>
          </Header>
          <Body aria-hidden="true">
            <p>
              Lorem Ipsum is simply dummy text of the printing and
              typesetting industry. Lorem Ipsum has been the
              industry's standard dummy text ever since 1966, when
              designers at Letraset and James Mosley, the librarian at
              St Bride Printing Library in London, took a 1914 Cicero
              translation and scrambled it to make dummy text for
              Letraset's Body Type sheets.
            </p>
            <p>
              It was popularised in the 1960s with the release of
              Letraset sheets containing Lorem Ipsum passages, and
              more recently with desktop publishing software like
              Aldus PageMaker including versions of Lorem Ipsum.
            </p>
            <p>
              Contrary to popular belief, Lorem Ipsum is not simply
              random text. It has roots in a piece of classical Latin
              literature from 45 BC, making it over 2000 years old.
              Richard McClintock, a Latin professor at Hampden-Sydney
              College in Virginia, looked up one of the more obscure
              Latin words, consectetur, from a Lorem Ipsum passage,
              and going through the cites of the word in classical
              literature, discovered the undoubtable source. Lorem
              Ipsum comes from sections 1.10.32 and 1.10.33 of "de
              Finibus Bonorum et Malorum" (The Extremes of Good and
              Evil) by Cicero, written in 45 BC. This book is a
              treatise on the theory of ethics, very popular during
              the Renaissance. The first line of Lorem Ipsum, "Lorem
              ipsum dolor sit amet..", comes from a line in section
              1.10.32.
            </p>
          </Body>
        </Wrapper>
      </Browser>
      {fix && (
        <Actions>
          {fix === 'blurrier' && (
            <SliderControl
              id="radius"
              label="Blur radius"
              min={0}
              max={16}
              value={radius}
              setValue={setRadius}
              previewRenderer={(val) => `${val}px`}
            />
          )}
          {fix === 'background' && (
            <SliderControl
              id="opacity"
              label="Background Opacity"
              min={0}
              max={1}
              step={0.1}
              value={opacity}
              setValue={setOpacity}
            />
          )}
        </Actions>
      )}
    </OuterWrapper>
  );
}

const OuterWrapper = styled.div`
  margin-bottom: 4rem;
  margin-top: 1rem;
`;

const Browser = styled(FakeBrowserWindow)`
  margin-inline: auto;
  max-width: 32rem;
`;

const Actions = styled.div`
  margin-inline: auto;
  margin-top: 2rem;
  max-width: 28rem;
`;

const Wrapper = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  overflow: hidden;
`;

const GlassyBackdrop = styled.div`
  position: absolute;
  inset: 0;
  height: 200%;
  background: linear-gradient(
    to bottom,
    var(--color-background),
    transparent 20%
  );
  backdrop-filter: blur(var(--radius));
  pointer-events: none;
`;

const HeaderContent = styled.div`
  position: relative;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 1.5rem var(--viewport-padding);

  ul {
    display: flex;
    gap: 1rem;
    list-style-type: none;
  }
  li {
    font-size: 0.875rem;
  }
`;

const Title = styled.div`
  font-size: 1rem;
  font-weight: var(--font-weight-bold);
`;

const Body = styled.div`
  margin-top: 1rem;
  padding-inline: var(--viewport-padding);

  p {
    margin-bottom: 1rem;
    font-size: 0.9375rem;
    text-align: justify;
  }
`;

export default TheProblem;
